module.exports = __webpack_public_path__ + "img/j-datuiwei-nan.3984071e.jpg";